if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
/* Gazeparts: autoplay native Shopify product videos */
(() => {
  function initGalleryVideoAutoplay(root = document) {
    root.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery.dataset.videoAutoplayReady === 'true') return;
      gallery.dataset.videoAutoplayReady = 'true';

      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      if (!viewer) return;

      const getSlides = () =>
        Array.from(viewer.querySelectorAll('.product__media-item'));

      const visibleArea = (element) => {
        const rect = element.getBoundingClientRect();
        const viewerRect = viewer.getBoundingClientRect();

        const width = Math.max(
          0,
          Math.min(rect.right, viewerRect.right) -
            Math.max(rect.left, viewerRect.left)
        );

        const height = Math.max(
          0,
          Math.min(rect.bottom, viewerRect.bottom) -
            Math.max(rect.top, viewerRect.top)
        );

        return width * height;
      };

      const playVideo = (slide) => {
        if (!slide) return;

        getSlides().forEach((item) => {
          if (item === slide) return;

          item.querySelectorAll('video').forEach((video) => {
            video.pause();
          });
        });

        const deferredMedia = slide.querySelector('deferred-media');
        const posterButton = deferredMedia?.querySelector(
          'button[id^="Deferred-Poster-"]'
        );

        const nativeVideoTemplate =
  deferredMedia?.querySelector('template')?.content?.querySelector('video');

if (
  posterButton &&
  nativeVideoTemplate &&
  !slide.querySelector('video')
) {
  posterButton.click();
}

        window.setTimeout(() => {
          const video = slide.querySelector('video');
          if (!video) return;

          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;

          const playPromise = video.play();
          if (playPromise) playPromise.catch(() => {});
        }, 150);
      };

      let frameRequested = false;

      const updateActiveVideo = () => {
        frameRequested = false;

        const slides = getSlides();
        if (!slides.length) return;

        const activeSlide =
          slides.find((slide) => slide.classList.contains('is-active')) ||
          slides.reduce((best, slide) =>
            visibleArea(slide) > visibleArea(best) ? slide : best
          );

        playVideo(activeSlide);
      };

      const scheduleUpdate = () => {
        if (frameRequested) return;
        frameRequested = true;
        window.requestAnimationFrame(updateActiveVideo);
      };

      viewer.addEventListener('scroll', scheduleUpdate, { passive: true });
      gallery.addEventListener('click', () => {
        window.setTimeout(scheduleUpdate, 100);
      });

      const observer = new MutationObserver(scheduleUpdate);
      observer.observe(gallery, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });

      scheduleUpdate();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initGalleryVideoAutoplay();
    });
  } else {
    initGalleryVideoAutoplay();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initGalleryVideoAutoplay(event.target);
  });
})();